import type { ContentType } from "@/components/ContentPlayerModal";

export const CONTENT_TYPE_MAP: Record<string, ContentType> = {
  "Video": "video",
  "Lectura": "reading",
  "Interactivo": "interactive",
  "Infografía": "infographic",
  "Clase con LIA": "lia-class",
  "Recurso": "resource",
  "Audio": "audio",
};
